import { render, staticRenderFns } from "./flashing-display-badge-list.vue?vue&type=template&id=3c2f57da&scoped=true&"
import script from "./flashing-display-badge-list.vue?vue&type=script&lang=js&"
export * from "./flashing-display-badge-list.vue?vue&type=script&lang=js&"
import style0 from "./flashing-display-badge-list.vue?vue&type=style&index=0&id=3c2f57da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2f57da",
  null
  
)

export default component.exports